<template>
  <div class="container-layers">
    <HeaderLeftContainer :title="$t(`views.leftBar.mapLayers`)" :back-to="{ name: 'default' }"></HeaderLeftContainer>

    <MapLayers />
  </div>
</template>

<script lang="ts" setup>
// Components import
import HeaderLeftContainer from '@/components/HeaderLeftContainer.vue'
import MapLayers from '@/components/MapLayers.vue'
</script>

<style scoped lang="scss">
:deep(.v-field__input) {
  color: rgb(var(--v-theme-lighten));
}

:deep(.v-field__prepend-inner) {
  color: rgb(var(--v-theme-lighten));
}

.container-layers {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
</style>
